export default __webpack_public_path__ + "static/media/gallery_06.a6f4d5bc.jpg";